export default "__VITE_ASSET__CxjUMWE4__"